<template>
    <FilterListBlock
        v-if="filter.values"
        ref="block"
        :name="filter.filter_name"
        :data-filter-name="name"
        :search-input-id="searchInputId"
        :is-open="isNotAllZeros"
        :is-label="
            filter.values.filter((el) => el.product_count > 0).length > 10
        "
        class="filter-list filter-list--checkbox"
    >
        <template #header>
            <FilterListSearch
                v-if="
                    filter.values.filter((el) => el.product_count > 0).length >
                    10
                "
                ref="search"
                :search-input-id="searchInputId"
                :filter="filter.values"
                :name="filter.filter_name"
                :filter-name="name"
                class="filter-list__search"
                :style="[
                    filter.values.filter((el) => el.product_count > 0).length >
                    10
                        ? null
                        : { display: 'none' }
                ]"
                @search="searchResults = $event"
            />
        </template>
        <ul v-if="filter && filter.values">
            <li
                v-for="(filterItem, index) in getFilters"
                :key="`${name}-${index}-${filterItem.value}`"
            >
                <UIInputCheckbox
                    v-if="filterItem.label"
                    :id="`${name}-${index}-${filterItem.value}`"
                    :value="filterItem.value"
                    :disabled="filterItem.product_count === 0"
                    :checked="
                        filterItem.active ||
                        (filter.active && filter.active === filterItem.value) ||
                        isActiveFilter(name, filterItem.value)
                    "
                    :aria-label="
                        'zaznacz filtr: ' +
                        filterItem.label +
                        ' ilość produktów:' +
                        filterItem.product_count
                    "
                    wrapper-class="filter-list__control"
                    @input="
                        (val) =>
                            toggleFilter(
                                val,
                                name,
                                filterItem.value,
                                filterItem.label
                            )
                    "
                >
                    <span class="filter-list__label">
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <span v-html="filterItem.label"></span>
                        <span>{{ filterItem.product_count }}</span>
                    </span>
                </UIInputCheckbox>
            </li>
        </ul>

        <template #footer>
            <button
                v-if="!searchResults.length && getMoreCount"
                class="filter-list__more btn--clear"
                @click="toggleMore"
            >
                <span
                    v-if="!showMore"
                    :aria-label="'Zobacz więcej - ' + filter.filter_name"
                >
                    {{ i18n('More') }}
                </span>
                <span
                    v-else
                    class="less"
                    :aria-label="'Zobacz mniej - ' + filter.filter_name"
                >
                    {{ i18n('Less') }}
                </span>
                <span class="icon-arrow-indicators icon"></span>
            </button>
        </template>
    </FilterListBlock>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import resizeObserver from '@vue/utils/resizeObserver.js'
import UIInputCheckbox from '@vue/UI/InputCheckbox'
import FilterListBlock from '../FilterListBlock'
import FilterListSearch from '../FilterListSearch'
import FilterListTypeBase from './FilterListTypeBase.vue'

export default {
    components: {
        UIInputCheckbox,
        FilterListBlock,
        FilterListSearch
    },
    extends: FilterListTypeBase,
    mixins: [resizeObserver],
    props: {
        limit: {
            type: Number,
            default: 4
        }
    },
    data() {
        return {
            showMore: false,
            searchResults: [],
            searchInputId: 'filter-search_' + this.name
        }
    },
    computed: {
        isNotAllZeros() {
            return this.getFilters.some((item) => item.product_count > 0)
        },
        getPaginatedFilters() {
            return [...this.getSortedFilters]
                ?.filter((filter) => filter.label)
                .splice(0, this.limit)
                ?.filter((filter) => filter.product_count > 0)
        },
        getFilters() {
            if (this.searchResults.length) {
                return this.searchResults
            }

            if (!this.showMore) {
                return this.getPaginatedFilters
            }

            return this.getSortedFilters || []
        },
        getSortedFilters() {
            const filters = [...this.filter.values].sort(
                (a, b) => b.product_count - a.product_count
            )

            if (this.filter.active) {
                const filter = filters.find(
                    (el) => el.value === this.filter.active
                )
                const index = filters.findIndex(
                    (el) => el.value === this.filter.active
                )
                filters.splice(index, 1)
                filters.unshift(filter)
            }
            return filters
        },
        getMoreCount() {
            return (
                this.filter.values.filter((el) => el.product_count > 0).length -
                this.getPaginatedFilters.length
            )
        },
        ...mapGetters(['i18n']),
        ...mapState(['filtersActive'])
    },
    watch: {
        searchResults() {
            if (this.$refs?.block?.$refs?.scrollable?.scrollTop) {
                this.$refs.block.$refs.scrollable.scrollTop = 0
            }
        }
    },
    methods: {
        toggleMore() {
            this.showMore = !this.showMore
        },
        isActiveFilter(name, value) {
            return (
                this.filtersActive[name] &&
                this.filtersActive[name].includes(Number(value))
            )
        }
    }
}
</script>
<style lang="scss">
.filter-list {
    li {
        &:not(:last-of-type) {
            margin-bottom: 1rem;
        }
    }

    &__more {
        display: flex;
        font-weight: $font-weight-bold;
        line-height: 42px;

        .less + .icon {
            transform: rotate(180deg);
        }
        .icon {
            width: 16px;
            height: 16px;
        }
    }

    &__control {
        label + label {
            width: 100%;
        }
    }

    &__label {
        display: flex;
        align-items: center;
        font-size: 14px;

        > span + span {
            padding-left: 1rem;
            margin-left: auto;
            color: $gray-lighter;
        }
    }
}
</style>
